export default __webpack_public_path__ + "static/media/MERN.c769b298.jpg";